<template>
  <div>
    <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
      <h3>{{ $lang('收件人信息') }}</h3>
      <div class="group-content">
        <el-form-item :label="$lang('姓名')" prop="receiverName">
          <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
          <BasePhoneInput :value="phoneVal2" :maxlength="16" v-model="formData.receiverMobilePhone"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('收件人备用手机号码')" prop="receiverTelphone">
          <BasePhoneInput :value="receiverTelphone" :maxlength="16" v-model="formData.receiverTelphone"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('公司')" prop="receiverCompany">
          <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20" />
        </el-form-item>
        <el-form-item :label="$lang('邮编')">
          <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('邮箱')">
          <el-input v-model.trim="formData.receiverEmail" :minlength="1" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="receiverProvinceName" prop="receiverProvinceName">
          <el-select filterable v-model="formData.receiverProvinceName" :key="formData.receiverProvinceId" @change="changeProvince($event)">
            <el-option v-for="item in provinceArray" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="receiverCityName" prop="receiverCityName">
          <el-select filterable v-model="formData.receiverCityName" :key="formData.receiverCityId" @change="changeCity($event)">
            <el-option v-for="item in cityList" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('收件区域')" prop="receiverAreaName" v-if="countryId === 1">
          <el-select filterable v-model="formData.receiverAreaName" :key="formData.receiverAreaId" @change="changeArea($event)">
            <el-option v-for="item in areaList" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
          <el-input v-model.trim="formData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-tooltip :disabled="receiverShortAddressDisabled" class="item" effect="dark" placement="bottom-start">
          <div slot="content" style="cursor: pointer;max-width: 250px;" @click="handleCopy(receiverShortAddressParseResults)">
            {{ receiverShortAddressParseResults }}
          </div>
          <el-form-item v-if="countryId === 1" :label="$lang('收件短地址')" prop="receiverShortAddress">
            <div class="label-tip" slot="label">
              <span :title="$lang('收件短地址')">{{ $lang('收件短地址') }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" class="short-tips">
                  <div>{{ $lang('Short address is a project from Saudi Arabia goverment.') }}</div>
                  <div>{{ $lang(' Introduction') }}:</div>
                  <a href="https://splonline.com.sa/en/national-address-1/" target="_blank">https://splonline.com.sa/en/national-address-1/</a>
                  <div>{{ $lang('Map for National address') }}:</div>
                  <a href="https://maps.splonline.com.sa" target="_blank">https://maps.splonline.com.sa</a>
                </div>
                <img class="tooltip-click" src="@/assets/images/exclamation-mark-icon.svg" alt="">
              </el-tooltip>
            </div>
            <el-input v-model="formData.receiverShortAddress" :placeholder="$lang('请输入收件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress('receiverShortAddressParseResults', 'receiverShortAddress')" />
          </el-form-item>
        </el-tooltip>

        <el-form-item v-if="countryId === 1" :label="$lang('收件建筑物编号')" prop="receiverBuildingNumber">
          <template slot="label"><span :title="$lang('收件建筑物编号')">{{ $lang('收件建筑物编号') }}</span></template>
          <el-input v-model="formData.receiverBuildingNumber" :placeholder="$lang('请输入收件建筑物编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('收件辅助编号')" prop="receiverReferenceNumber">
          <template slot="label"><span :title="$lang('收件辅助编号')">{{ $lang('收件辅助编号') }}</span></template>
          <el-input v-model="formData.receiverReferenceNumber" :placeholder="$lang('请输入收件辅助编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>

        <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
          <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
        </el-form-item>
      </div>
      <h3>{{ $lang('货物信息') }}</h3>
      <div class="group-content">
        <el-form-item :label="$lang('件数')" prop="packageNumber">
          <el-input-number v-model="formData.packageNumber" label="描述文字" :step="1" :precision="0" :min="1" :max="999"></el-input-number>
        </el-form-item>
        <el-form-item :label="$lang('物品类型')" prop="goods">
          <Base-Select
            v-model="formData.goods"
            :props="{ label: 'name', value: 'code', res: 'appArticleTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
            @change="changeGoods"
          ></Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('物品名称')" prop="goodsName">
          <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
          <el-input-number v-model="formData.packageTotalWeight" label="描述文字" :precision="2" :min="0" :max="99999.99"></el-input-number>
        </el-form-item>
        <el-form-item :label="$lang('结算方式')" prop="payment">
          <Base-Select
            v-model="formData.payment"
            :disabled="true"
            :props="{ label: 'name', value: 'code', res: 'appPaymentMannerVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
          >
          </Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('支付方式')" prop="paidMode">
          <Base-Select
            v-model="formData.paidMode"
            :props="{ label: 'name', value: 'code', res: 'appPayTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
            :disabled="true"
          >
          </Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('产品类型')" prop="expressType">
          <Base-Select
            v-model="formData.expressType"
            :props="{ label: 'productName', value: 'productCode', res: 'appProductTypeVOList', valueObj: true }"
            :dic="someExpressTypeData"
            :placeholder="$lang('请选择')"
          >
          </Base-Select>
          <!-- <Base-Select
            v-model="formData.expressType"
            :props="{ label: 'name', value: 'code', res: 'appProductTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
          >
          </Base-Select> -->
        </el-form-item>
        <el-form-item :label="$lang('参考运费')" prop="standardValue">
          <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="cod">
          <!-- <el-checkbox class="btn-insured" v-model="codFlag" @change="checkCod">{{ $lang('是否代收货款') }}</el-checkbox> -->
          <el-checkbox class="btn-insured" v-model="formData.codNeed" @change="checkCod" :disabled='isReverse'>{{ $lang('是否代收货款') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
          <el-select :disabled="true" v-model="formData.codCurrencyTypeName" @change="changeCodCurrency">
            <el-option v-for="item in codCurrencyType" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
          <el-input
            :disabled="!formData.codNeed"
            v-model="formData.codMoney"
            :label="$lang('描述文字')"
            :placeholder="$lang('请输入对应的金额')"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            @blur="codMoneyBlur"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
          <el-input v-model="formData.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('平台')" prop="platformName">
          <el-input v-model.trim="formData.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1" :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('客户账号')" prop="customerAccount">
          <el-input class="customerStyle" v-model.trim="formData.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1" :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item style="width: auto; margin-top: 20px" prop="isUnpackEnabled">
          <el-switch v-model="formData.isUnpackEnabled" :active-text="$lang('是否允许客户开箱验视')"> </el-switch>
        </el-form-item>
        <el-form-item :label="$lang('是否购买赔偿上限服务')" prop="insured" class="insured-info">
          <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === 'PP_PM' || !insureSwitch " :placeholder="$lang('请选择')"  @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
          </el-form-item>
          <el-form-item :label="$lang('货物价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
            <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="0" :controls="false" :min="0" :max="8000"></el-input-number>
            <!-- <el-input  @keyup.enter.native="searchData(false)" v-model="formData.declaredValue" :placeholder="$lang('请输入')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
          </el-form-item>
          <el-form-item :label="$lang('赔偿上限服务费')" prop="insuredValue" v-show="formData.insured===1">
          <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { RULES, checkAddressFormat, integerWeight, checkGoodsName, phoneAndMobile, isNull } from '@utils/rules'
import { mapGetters } from 'vuex'
import * as Api from '@api/base/public'
import { DIC } from '@constants'
import {
  getComCost,
  getSettlement,
  getsysCurrencyType,
  customerCod,
  getComputationCost,
  getCalc,
  getShortAddress,
  judgeShortAddress
} from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import { copyText } from '@/utils/util'

import _ from 'lodash'
export default {
  props: {
    rowData: {
      type: Object,
      default: _ => {
        return {}
      }
    }
  },
  data () {
    return {
      DIC,
      rules: {
        receiverName: [RULES.required, { validator: isNull }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        // receiverStreet: [RULES.requiredTrim],
        goods: [RULES.required],
        goodsName: [RULES.required, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        // paidMode: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        payment: [RULES.requiredSelect],
        isUnpackEnabled: [RULES.required],
        insured: [RULES.requiredSelect],
        receiverShortAddress: [RULES.codeNumber],
        receiverReferenceNumber: [RULES.twenty],
        receiverBuildingNumber: [RULES.twenty],

      },
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('省份'),
      senderCityName: this.$lang('寄件城市'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      provinceArray: [],
      cityList: [],
      areaList: [],
      codCurrencyType: [],
      phoneVal2: '',
      receiverTelphone: '',
      codFlag: false,
      codIsInput: true,
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      formData: {
        receiverName: '',
        receiverMobilePhone: '',
        receiverTelphone: '',
        receiverCompany: '',
        receiverPostalCode: '',
        receiverEmail: '',
        receiverProvinceName: '',
        receiverProvinceId: '',
        receiverCityName: '',
        receiverCityId: '',
        receiverStreet: '',
        receiverDetailedAddress: '',
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        insured: 0, // 是否购买赔偿上限服务1是，0否,
        declaredValue: 0, // 物品价值,
        insuredValue: 0, // 赔偿上限服务费,
        packageTotalWeight: '',
        codCurrencyTypeName: '',
        codCurrencyTypeCode: '', // 代收货款币别code
        codMoney: '',
        codFee: '',
        platformName: '',
        customerAccount: '',
        payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 }, // 结算方式
        paymentModeId: '42', // 结算方式id,
        paymentModeCode: 'PP_PM', // 结算方式编码,
        paymentModeName: this.$lang('Monthly'), // 结算方式名称,
        isUnpackEnabled: 0,
        expressType: '', // 产品类型
        expressTypeCode: '', // 产品类型code
        expressTypeName: '', // 产品类型name
        senderShortAddress: '', // 寄件短地址
        receiverShortAddress: '', // 收件端地址
      },
      receiverShortAddressParseResults: '', // 收件短地址解析结果
      judgeShortAddressDebounce: _.debounce(this.judgeShortAddress, 300)
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    insureSwitch() {
      return (this.$store.state.base.user || {}).insureSwitch === 1
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryCode () {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    calcStandardCostNum () {
      const { expressType, payment, paidMode, receiverCityName, packageTotalWeight } = this.formData
      return {
        expressType,
        payment,
        paidMode,
        receiverCityName,
        packageTotalWeight
      }
    },
    someExpressTypeData () {
      const { receiverExpressTypeData: arr1, senderExpressTypeData: arr2 } = this
      const someExpressTypeData = arr1.filter(item1 => arr2.some(item2 => item2.productId === item1.productId))
      return someExpressTypeData
    },
    isReverse() {
      const { expressTypeCode } = this.formData
      return expressTypeCode === 'Reverse' || expressTypeCode === `Reverse${this.countryCode}` || expressTypeCode === 'ReverseKW'
    },
    receiverShortAddressDisabled() {
      return !(this.receiverShortAddressParseResults)
    }
  },
  watch: {
    countryCode: {
      handler (val) {
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          this.senderProvinceName = this.$lang('寄件酋长国')
          this.senderCityName = this.$lang('寄件区域')
          this.receiverProvinceName = this.$lang('收件酋长国')
          this.receiverCityName = this.$lang('收件区域')
        }
      },
      immediate: true
    },
    rowData: {
      handler (obj) {
        console.log('详情数据------------>>', obj)
        // const { formData } = this
        // const newFormData = Object.keys(obj).reduce((acc, cur) => {
        //   if (formData.hasOwnProperty(cur)) {
        //     acc[cur] = obj[cur]
        //   }
        //   return acc
        // }, {})
        const goods = {
          id: obj.goodsTypeId,
          code: obj.goodsTypeCode,
          name: obj.goodsTypeName
        }
        const paidMode = {
          id: obj.paidModeId || '',
          code: obj.paidModeCode || '',
          name: obj.paidModeName || ''
        }
        const payment = {
          id: 42 || obj.paymentModeId,
          code: 'PP_PM' || obj.paymentModeCode,
          name: 'PP_PM' || obj.paymentModeName,
        }
        const expressType = {
          productCode: obj.expressTypeCode, // 产品类型code
          productName: obj.expressTypeName, // 产品类型name
        }
        // if (Object.keys(expressType).some(key => !expressType[key])) expressType = ''
        obj.isUnpackEnabled = !!obj.isUnpackEnabled
        obj.codNeed = !!obj.codNeed
        obj.declaredValue = obj.declaredValue ? obj.declaredValue : 0
        this.formData = {
          // ...this.formData,
          // ...newFormData,
          ...obj,
          goods,
          payment,
          paidMode,
          expressType
        }
        this.getProvince()
        this.getCurrencyTypeList()
        if (this.countryId === 1 && this.formData.receiverShortAddress) {
          this.judgeShortAddressDebounce('receiverShortAddressParseResults', 'receiverShortAddress')
        }
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler (val) {
        const params = _.cloneDeep(val)
        params.isUnpackEnabled = +params.isUnpackEnabled
        params.codNeed = +params.codNeed
        for (const key in params) {
          if (key.includes('Time') || key.includes('time')) delete params[key]
        }
        this.$emit('updateformData', params)
      },
      deep: true,
      immediate: true
    },
    calcStandardCostNum: {
      handler (newV, oldV) {
        if (!_.isEqual(newV, oldV)) {
          this.calcStandardCost(this.formData)
        }
      },
      deep: true
    },
    // someExpressTypeData: {
    //   handler (arr) {
    //     if (!arr.length) return
    //     const hasProduct = arr.some(item => item.productName === this.formData.expressTypeName)
    //     if (!hasProduct) {
    //       this.formData.expressType = ''
    //       this.formData.expressTypeCode = ''
    //       this.formData.expressTypeName = ''
    //     }
    //   },
    //   deep: true,
    //   immediate: false,
    // },
    'formData.expressType': {
      deep: true,
      immediate: false,
      async handler(val) {
        this.formData.expressTypeCode = val.productCode
        this.formData.expressTypeName = val.productName
        // Reverse 禁用报价费勾选
        if (this.isReverse) {
          this.formData.codNeed = false
          this.formData.codCurrencyTypeName = ''
          this.formData.codCurrencyTypeCode = ''
          this.formData.codMoney = ''
          this.formData.codFee = ''
        }
      }
    },
    // 赔偿上限服务费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    // 物品类型
    async 'formData.goods'(val) {
      console.log(val, 'goods_________')
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: 0 })
        this.formData.insuredValue = 0
      }
    },
    // 代收货款手续费计算
    async 'formData.codMoney'(val) {
      const { codMoney } = this.formData
      const { decimalPoint } = this.userInfo // 货币小数位数
      if (parseFloat(codMoney) > 0) {
        if (parseFloat(codMoney) > this.codNumber) {
          this.$message.error(this.$lang('代收货款金额超额，最高限额为') + this.codNumber)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.')[1].length > (decimalPoint || 6)) {
          this.$message.error(`${this.$lang('代收货款不能超过')} ${decimalPoint || 6} ${this.$lang('位小数！请重新输入')}`)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.formData, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    }
    // 产品类型
    // async 'formData.expressType'(val) {
    //   const { productCode: expressTypeCode, productName: expressTypeName } = val
    //   // console.log('77777', expressTypeCode + ',' + expressTypeName)
    //   // const taxationVal = this.someExpressTypeData.find(item => item.code === expressTypeCode)
    //   // this.formData.taxation = taxationVal ? taxationVal.taxRate : 0
    //   // console.log('88888', this.formData.taxation)
    //   Object.assign(this.formData, { expressTypeCode, expressTypeName })
    //   const { senderCityName, receiverCityName, packageTotalWeight } = this.formData
    //   if (senderCityName && receiverCityName && val && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     // console.log(222222222)
    //     Object.assign(this.formData, res)
    //   }
    //   const res = await this.getComputationCost(this.formData)
    //   Object.assign(this.formData, { insuredValue: res })
    // }
  },
  methods: {
    // 解析短地址
    async judgeShortAddress(type, prop) {
      try {
        const { senderShortAddress, receiverShortAddress } = this.formData
        const params = {
          shortAddress: type === 'senderShortAddressParseResults' ? senderShortAddress : receiverShortAddress
        }
        if (!params.shortAddress) {
          this[type] = ''
          this.formData[prop] = ''
          return
        }
        const regex = /^[A-Za-z]{4}\d{4}$/
        if (!regex.test(params.shortAddress)) {
          this.formData[prop] = ''
          this.$message.error(this.$lang('不符合短地址规则'))
          return
        }
        const { code, data } = await judgeShortAddress(params)
        if (code === RESPONSE_SUCCESS && data && data === true) {
          this.getShortAddress(type)
        } else {
          this[type] = ''
          this.formData[prop] = ''
          this.$message.error(this.$lang('未找到该短地址对应的地址，请核实后重试。'))
        }
      } catch (error) {
        this[type] = ''
      }
    },
    async getShortAddress(type) {
      try {
        const { senderShortAddress, receiverShortAddress } = this.formData
        const params = {
          shortAddress: type === 'senderShortAddressParseResults' ? senderShortAddress : receiverShortAddress
        }
        if (!params.shortAddress) {
          this[type] = ''
          return
        }
        const { code, data, msg } = await getShortAddress(params)
        if (code === RESPONSE_SUCCESS) {
          this[type] = data || ''
        } else {
          this[type] = ''
          this.$message.error(msg)
        }
      } catch (error) {
        this[type] = ''
      }
    },
    // 复制短地址解析结果
    handleCopy(data) {
      copyText(data)
      this.$message.success(this.$lang('复制成功'))
    },
    codMoneyBlur () {
      // const reg = /^(\d+)(.\d{0,2})?$/
      // const codMoney = +this.formData.codMoney
      // if (!reg.test(codMoney)) {
      //   this.$message.error(this.$lang('代收货款格式有误！'))
      //   this.formData.codMoney = 0
      //   this.formData.codFee = ''
      // }
      // if (codMoney > 3000) {
      //   this.$message.error(`${this.$lang('代收货款金额超额，最高限额为')}3000`)
      //   this.formData.codMoney = 0
      //   this.formData.codFee = ''
      // }
    },
    // 获取酋长国数据
    async getProvince () {
      const { data, succ, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (succ) {
        this.provinceArray = data
        this.getCity(this.formData.receiverProvinceId)
        this.getSendCity(this.formData.senderProvinceId)
      } else {
        this.$message.error(msg)
      }
    },
    async getSendCity (parentId) {
      const { data, succ } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId })
      if (succ) {
        const obj = this.findDataObj(data, this.formData.senderCityId)
        this.senderExpressTypeData = (obj && obj.products) ? obj.products : []
      }
    },
    async getCity (parentId, setDefaultCity) {
      const { data, succ, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId })
      if (succ) {
        this.cityList = data
        if (setDefaultCity === 'setDefaultCity') {
          this.formData.receiverCityId = data[0].id
          this.formData.receiverCityName = data[0].nativeName
          this.receiverExpressTypeData = data[0].products || []
          if (this.someExpressTypeData && this.someExpressTypeData.length) {
            this.formData.expressType = this.someExpressTypeData[0]
            this.formData.expressTypeCode = this.someExpressTypeData[0].productCode
            this.formData.expressTypeName = this.someExpressTypeData[0].productName
          } else {
            this.formData.expressType = ''
            this.formData.expressTypeCode = ''
            this.formData.expressTypeName = ''
            if (this.receiverExpressTypeData.length && this.senderExpressTypeData.length) {
              this.$message.error(this.$lang('产品类型不匹配，无法下单'))
            }
          }
          if (this.countryId === 1) {
            await this.getArea(data[0].id, 1)
          }
        } else {
          const obj = this.findDataObj(data, this.formData.receiverCityId)
          this.receiverExpressTypeData = (obj && obj.products) ? obj.products : []
          if (this.countryId === 1) {
            await this.getArea(data[0].id)
          }
        }
      } else {
        this.$message.error(msg)
      }
    },
    async getArea (parentId, val) {
      const { data, succ, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId })
      if (succ) {
        this.areaList = data
        if (val === 1) {
          this.formData.receiverAreaId = data[0].id
          this.formData.receiverAreaName = data[0].nativeName
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取币别
    async getCurrencyTypeList () {
      const { data, succ, msg } = await getsysCurrencyType()
      if (succ) {
        this.codCurrencyType = data
        if (this.formData.codMoney && !this.isReverse) {
          this.formData.codCurrencyTypeName = this.codCurrencyType[0].name // 代收货款币别
          this.formData.codCurrencyTypeCode = this.codCurrencyType[0].coding // 代收货款币别code
        }
      } else {
        this.$message.error(msg)
      }
    },
    changeProvince (val) {
      const obj = this.findDataObj(this.provinceArray, val)
      this.formData.receiverProvinceId = val
      this.formData.receiverProvinceName = obj.nativeName
      this.getCity(val, 'setDefaultCity')
      this.formData.receiverAreaId = ''
      this.formData.receiverAreaName = ''
    },
    changeCity (val) {
      const obj = this.findDataObj(this.cityList, val)
      this.formData.receiverCityId = val
      this.formData.receiverCityName = obj.nativeName
      this.receiverExpressTypeData = obj.products
      if (this.countryId === 1) {
        this.getArea(val, 1)
      }
    },
    changeArea(val) {
      const obj = this.findDataObj(this.areaList, val)
      this.formData.receiverAreaId = val
      this.formData.receiverAreaName = obj.nativeName
    },
    findDataObj (arr, val, key = 'id') {
      return arr.find(item => item[key] === val)
    },
    changeGoods (val) {
      const { code, id, name } = val
      this.formData.goodsTypeId = id
      this.formData.goodsTypeCode = code
      this.formData.goodsTypeName = name
    },
    changeCodCurrency (val) {
      const obj = this.findDataObj(this.codCurrencyType, val, 'code')
      this.formData.codCurrencyTypeCode = obj.code
      this.formData.codCurrencyTypeName = obj.name
    },
    // 是否代收货款
    async checkCod (val) {
      if (val) {
        const res = await customerCod({ customerCode: this.user.customerCode })
        if (res && res.data && res.data.isOpenCod === 1) {
          // this.formData.codCurrencyTypeName = 'SAR' // 代收货款币别
          // this.formData.codCurrencyTypeCode = 'SAR' // 代收货款币别code
          this.codNumber = res.data.maxCollectionMoney
          this.codIsInput = false
          this.formData.codCurrencyTypeName = this.codCurrencyType[0].name // 代收货款币别
          this.formData.codCurrencyTypeCode = this.codCurrencyType[0].code // 代收货款币别code
        } else {
          this.$message.error(this.$lang('您未开通代收货款服务，请联系合作网点！'))
        }
      } else {
        this.formData.codCurrencyTypeName = '' // 代收货款币别
        this.formData.codCurrencyTypeCode = '' // 代收货款币别code
        this.formData.codMoney = 0
        this.formData.codFee = '' // 代收货款手续费
        this.codIsInput = true
      }
    },
    /**
     * 是否购买赔偿上限服务
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = 0
        this.formData.insuredValue = 0
      }
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement (providerId, cityId, packageTotalWeight, type) {
      const reqData = { providerId, cityId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost (number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smModeType = 1
            break
          case 319:
            smModeType = 2
            break
          case 321:
            smModeType = 3
            break
        }
      }
      // 服务方式-serviceMethodCode 写死寄件上门 01
      const reqData = { startAddressId, endAddressId, number, productTypeCode, serviceMethodCode: '01', ...{ smMode: smModeType }}
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 赔偿上限服务费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 运费计算
    async calcStandardCost (data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, packageTotalWeight, paymentModeId, expressTypeCode } = data
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId && expressTypeCode) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
        this.formData = {
          ...this.formData,
          ...obj,
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;
}
.label-tip {
  display: flex;
  align-items: center;
}
.tooltip-click {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0 5px;
}
.short-tips {
  a {
    color: #28CFFE;
  }
}
</style>
